import axios from "axios";
import { BASE_URL } from "@/config";




// 封装常用的API请求

// 获取可访问的KOL列表
export const get_accessable_kol_list = (platform_type) => {
  return axios.get(BASE_URL + "get_accessable_kol_list/", {
    params: {
        platform_type: platform_type
    }
  });
};

// 获取剪辑素材列表
export const get_clip_material_list = ({kol_list, key_word, start_date, end_date, exclude_virtual, with_detail}) => {
  return axios.get(BASE_URL+"get_video_material_list/", {
    params: {
      kol_list: kol_list,
      key_word: key_word,
      start_date: start_date,
      end_date: end_date,
      exclude_virtual: exclude_virtual,
      with_detail: with_detail
    },
  });
};

// 搜索热点视频
export const search_hot_videos = (keyword, uid, start_date, end_date) => {
  return axios.get(BASE_URL + "search_hot_videos/", {
    params: {
      keyword: keyword,
      uid: uid,
      start_date: start_date,
      end_date: end_date
    }
  });
};

// 获取热点视频溯源信息
export const get_hot_video_source_trace = (video_id) => {
  return axios.get(BASE_URL + "get_hot_video_source_trace/", {
    params: {
      video_id: video_id
    }
  });
};

// 获取视频详细素材信息（含字幕）
export const get_video_material_info = (trans_id) => {
  return axios.get(BASE_URL + "video_material/", {
    params: {
      trans_id: trans_id
    }
  });
};

export const get_adjacent_transcription = (params) => {
  return axios.get(BASE_URL + "get_adjacent_transcription/", {
    params: params
  });
};

export const query_commodity_explain_records = ({kol_list, key_word, start_date, end_date}) => {
    return axios.get(BASE_URL+"query_commodity_explain_records/", {
        params: {
          kol_list: kol_list,
          start_date: start_date,
          end_date: end_date,
          commodity_name: key_word
        },
    });
}

export const query_sampled_commodity_explain_records = ({kol_list, key_word, start_date, end_date}) => {
    return axios.get(BASE_URL+"query_sampled_commodity_explain_records/", {
        params: {
          kol_list: kol_list,
          start_date: start_date,
          end_date: end_date,
          commodity_name: key_word
        },
    });
}

export const query_outter_commodity_explanation = ({kol_list, key_word, start_date, end_date}) => {
    return axios.get(BASE_URL+"query_outter_commodity_explanation/", {
        params: {
          kol_list: kol_list,
          start_date: start_date,
          end_date: end_date,
          key_word: key_word
        },
    });
}

export const query_outter_commodity_group = ({kol_list, key_word, start_date, end_date}) => {
    return axios.get(BASE_URL+"query_outter_commodity_group/", {
        params: {
          kol_list: kol_list,
          start_date: start_date,
          end_date: end_date,
          key_word: key_word
        },
    });
}


// --- 服饰时间轴相关接口 ---

/**
 * 触发服饰分析
 * @param {string} transcription_id 
 */
export const generate_clothing_timeline = (transcription_id) => {
    return axios.post(`${BASE_URL}api/clothing-timeline/generate`, {
        transcription_id
    });
};

/**
 * 获取服饰时间轴数据
 * @param {string} transcription_id 
 */
export const get_clothing_timeline = (transcription_id) => {
    return axios.get(`${BASE_URL}api/clothing-timeline/${transcription_id}`);
};

/**
 * 服饰姿态搜索
 * @param {Object} data 
 */
export const search_clothing_poses = (data) => {
    return axios.post(`${BASE_URL}api/clothing-timeline/search-pose`, data);
};

/**
 * 下载单帧图片
 * @param {string} transcription_id 
 * @param {number} sec 
 */
export const download_frame_image = async (transcription_id, sec) => {
  const url = `${BASE_URL}api/clothing-timeline/frame/?transcription_id=${transcription_id}&sec=${Math.floor(sec)}`;
  
  try {
    const response = await axios.get(url, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', `frame_${transcription_id}_${Math.floor(sec)}s.jpg`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download frame failed:', error);
    throw error;
  }
};

/**
 * 下载视频片段
 * @param {string} transcription_id 
 * @param {number} start 
 * @param {number} end 
 */
export const download_clip_video = async (transcription_id, start, end) => {
  const url = `${BASE_URL}api/clothing-timeline/clip/?transcription_id=${transcription_id}&start=${start.toFixed(2)}&end=${end.toFixed(2)}`;
  
  try {
    const response = await axios.get(url, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', `clip_${transcription_id}_${start.toFixed(1)}s_${end.toFixed(1)}s.mp4`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download clip failed:', error);
    throw error;
  }
};

// 获取用户历史导出记录
export const get_recent_user_slices = (payload = {}) => {
    return axios.post(BASE_URL + "get_recent_user_slices/", payload);
};

// 获取特定切片的详情（含展开后的 words）
export const get_slice_details = (slice_id) => {
  return axios.get(BASE_URL + `get_slice_details/${slice_id}`);
};

// 批量创建剪切任务
export const create_batch_slices = (data) => {
    return axios.post(BASE_URL + "create_batch_slices/", data);
};

// 获取达人AI剪辑专属画像配置
export const get_influencer_ai_profile = (kol_id) => {
  return axios.get(BASE_URL + `influencer_ai_profile/${kol_id}`);
};

// 更新达人AI剪辑专属画像配置
export const update_influencer_ai_profile = (profile) => {
  return axios.post(BASE_URL + "influencer_ai_profile/", profile);
};
